import { render, staticRenderFns } from "./xpbuttom.vue?vue&type=template&id=74050602&scoped=true&"
import script from "./xpbuttom.vue?vue&type=script&lang=js&"
export * from "./xpbuttom.vue?vue&type=script&lang=js&"
import style0 from "./xpbuttom.vue?vue&type=style&index=0&id=74050602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74050602",
  null
  
)

export default component.exports